import { faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons'
import type { FC } from 'react'

import ActionButton from '@/components/ActionButton'

interface Props {
  onClick: () => void
  disabled?: boolean
}

const GuideMeButton: FC<Props> = ({ onClick, disabled = false }) => (
  <>
    <ActionButton
      disabled={disabled}
      label="Guide Me"
      icon={faChalkboardTeacher}
      onClick={onClick}
    />
  </>
)

export default GuideMeButton
